import { MenuItem, NotificationState } from 'models';
import { mode } from 'utils';

interface Children {
  id: string;
  label: string;
  order: number;
  parent: string;
}

interface Parent {
  id: string;
  label: string;
  order: number;
  childrens: Children[];
}

interface ModifiedMenu {
  parents: { [key: string]: Parent };
  childrens: { [key: string]: Children };
}

const hiddenParents = mode.dev() ? [] : ['events'];

export function modifyMenu(menu: MenuItem[]) {
  if (!menu.length) return {};

  const { parents, childrens } = menu.reduce(
    (acc, next) => {
      if (
        (next.Parent && hiddenParents.includes(next.Parent)) ||
        hiddenParents.includes(next.Id)
      ) {
        return acc;
      }

      if (next.Parent) {
        acc['childrens'][next.Id] = {
          id: next.Id,
          label: next.Label,
          order: next.Order,
          parent: next.Parent,
        };
      } else {
        acc['parents'][next.Id] = {
          id: next.Id,
          label: next.Label,
          order: next.Order,
          childrens: [],
        };
      }

      return acc;
    },
    { parents: {}, childrens: {} } as ModifiedMenu
  );

  Object.values(childrens).forEach((child) => {
    parents[child.parent].childrens = [
      ...parents[child.parent].childrens,
      child,
    ];
  });

  return parents;
}

export function pathToId(path: string) {
  return path.replace(/\//, '');
}

export function pathToEntityName(path: string) {
  switch (path) {
    case 'user-spaces':
      return 'user_spaces';
    case 'key-order':
      return 'key_order';
    case 'eventsinformation':
      return 'eventsinformation';
    case 'repair':
      return 'repair';
    case 'newsletters':
      return 'notifications';
    case 'event-list':
      return 'messages';
    case 'incident':
      return 'incident';
    case 'board-eventsinformation':
      return 'board_eventsinformation';
    case 'todo':
      return 'task';
  }
}

export function countParentNotifications(
  childrens: Children[],
  notifications: NotificationState
) {
  return childrens.reduce((acc, next) => {
    const key = pathToEntityName(next.id);
    const notification = key ? notifications[key] : null;

    if (notification) return acc + notification.amount;
    return acc;
  }, 0);
}

export function countChildNotification(
  id: string,
  notifications: NotificationState
) {
  const key = pathToEntityName(id);

  return key ? notifications[key].amount : 0;
}
